import { configWithoutToken } from "./config";
import { encrypt, getWebToken } from "../utils/tokenUtils";
import { ITokenData } from "../models/ITokenData";

export const ensureWebToken = async (): Promise<void> => {
  const existing = getWebToken();
  if (existing && new Date(existing.expiration) > new Date()) return;

  const sendObj = {
    email: "test123998@gmail.com",
    password: "Mutfacik2024",
    deviceId: "",
  };

  const res = await configWithoutToken.post<ITokenData>("Auth/Token", sendObj);
  localStorage.setItem("MA", encrypt(JSON.stringify(res.data)));
};
